import { Box } from '@chakra-ui/react';

import Head from 'View/schedule-ruleset/section/head';
import Filter from 'View/schedule-ruleset/section/filter';
import Table from 'View/schedule-ruleset/section/table';
import FormUpsert from 'View/schedule-ruleset/section/form-upsert';
import ScheduleRulesetProvider from 'View/schedule-ruleset/state';

import styles from './styles.module.css';

const ScheduleRuleset = () => {
  return (
    <Box className={styles['schedule-ruleset__container']}>
      <Head />
      <Filter />
      <Table />
      <FormUpsert />
    </Box>
  );
};

const ScheduleRulesetContainer = () => <ScheduleRulesetProvider children={<ScheduleRuleset />} />;

export default ScheduleRulesetContainer;
